import styled from 'styled-components';
import TickIconSvg from './tick-icon.svg';

const TickIcon = styled(TickIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || '#4a4a4a'};
`;

export default TickIcon;

